// Promotional pricing utilities for Course Sale campaign
// This calculates display prices while keeping checkout prices unchanged

export const getPromotionalPricing = (currentPrice) => {
  const price = parseFloat(currentPrice);
  
  if (price < 400) {
    return {
      originalPrice: price + 50,
      salePrice: price,
      savings: 50,
      discountPercent: Math.round((50 / (price + 50)) * 100)
    };
  } else {
    return {
      originalPrice: price + 150,
      salePrice: price,
      savings: 150,
      discountPercent: Math.round((150 / (price + 150)) * 100)
    };
  }
};

export const PROMO_ACTIVE = true; // Toggle this to enable/disable the sale display
export const PROMO_BADGE_TEXT = "Course Sale";
